<template lang="pug">
.vprContentsThemeComponent
  .header( @click="toggle" )
    .title {{ theme.title }}
    ui-collapse-button.collapseButton( :is-collapsed="isOpened" )

  .subthemes(v-if="isOpened")
    .subtheme(
      v-for="subtheme in theme.subthemes"
      :key="subtheme.id"
      @click="onSubthemeClick(subtheme.id)"
    )
      .subthemeTitle(
        :class="{_selected: subtheme.countDoneTasks > 0 && !isReadonly}"
      ) {{ subtheme.title }}
        .hint(v-if="isReadonly")
          | Нет доступа к ВПР. Активируйте демо&#8209;доступ или приобретите ВПР.
      .counters {{ subtheme.countDoneTasks }}/{{ subtheme.countTasks }}

</template>

<script>
import VprTheme from '@/models/VprTheme'
import useFlag from '@/_core/hooks/useFlag'
import router from '@/router'

export default {
  props: {
    theme: {
      type: VprTheme,
      required: true
    },
    isReadonly: Boolean
  },
  setup (props) {
    const { flag: isOpened, toggle } = useFlag('_opened', false)

    const onSubthemeClick = subthemeId => {
      if (props.isReadonly) return
      router.push({ name: 'VprControlworks', params: { subthemeId: subthemeId } })
    }

    return { isOpened, toggle, onSubthemeClick }
  }
}
</script>

<style lang="sass" scoped>
.vprContentsThemeComponent
  border-radius: $brM
  background-color: $cElements
  padding: 5*$u 7.5*$u 4*$u 7.5*$u
  @media (max-width: $XLWidth)
    padding: 4*$u

  > .header
    display: flex
    justify-content: space-between
    @include gap(5*$u)
    cursor: pointer

    > .title
      flex: 1
      @include font('h2')
      @media (max-width: $XLWidth)
        @include font('m-h3')

    > .collapseButton
      flex: 0 0 8*$u

  > .subthemes
    margin-top: 1*$u
    > .subtheme
      display: flex
      justify-content: space-between
      margin-top: 3*$u
      @include gap(1*$u)
      cursor: pointer

      > .subthemeTitle
        @include font('t18-regular')
        position: relative
        @media (max-width: $XLWidth)
          @include font('t16-regular')

        > .hint
          position: absolute
          transition: $animationSpeed
          pointer-events: none
          opacity: 0
          background: $cWhite
          padding: 3*$u 4*$u
          left: 0
          top: 100%
          width: 77*$u
          z-index: 1
          border-radius: $brS
          @include font('t14-regular')
          line-height: 1.25
          color: $cText
          box-shadow: $boxShadow

        &._selected
          color: $cDarkBlue

      &:hover
        > .subthemeTitle
          color: $cBlue
          > .hint
            opacity: 1

      > .counters
        @include font('t18-demibold')
        @media (max-width: $XLWidth)
          @include font('t16-demibold')
</style>
